import React, { createContext, useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { showError } from "../../../services/ModalService";
import { PreCandidateService } from "../../../services/PreCandidate";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/CommonService";
import { QueryString } from "../../../common/helper";
import { jobRoleService } from "../../../services/JobRoleService";
import { translateAndSortAscendant } from "../../../common/helper";
import moment from "moment";

const PreCandidateContext = createContext();

export default function PreCandidateProvider({ id, children }) {
  const [errors, setErros] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [modalContactShow, setModalContactShow] = useState(false);
  const [modalHistoryShow, setModalHistoryShow] = useState(false);
  const [historyPreCandidate, setHistoryPreCandidate] = useState([]);
  const [updatePreCandidateList, setUpdatePreCandidateList] = useState(false);
  const [managers, setManagers] = useState([]);
  const [precandidateSelected, setPreCandidateSelected] = useState("");
  const [precandidate, setPrecandidate] = useState({});
  const [
    showCreteInterviewConfirmation,
    setShowCreteInterviewConfirmation
  ] = useState(false);
  const [
    alertMessageToCreateInterview,
    setAlertMessageToCreateInterview
  ] = useState("");
  const [interviewId, setInterviewId] = useState(0);
  const [isPreCandidateLoading, setIsPreCandidateLoading] = useState(false);
  const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [contactPreCandidate, setContactPreCandidate] = useState({
    nextContactDate: new Date(),
    preCandidateId: 0
  });
  const [reasons, setReasons] = useState([]);
  const [preCandidateList, setPreCandidateList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [availabilityStatus, setAvailabilityStatus] = useState([]);
  const [contactavailabilityStatus, setContactavailabilityStatus] = useState(
    []
  );
  const [searchObject, setSearchObject] = useState({ teamOnly: true });
  const [modalErrorOpen, setModalErrorOpen] = useState(false);
  const [modalErrorRedirect, setModalErrorRedirect] = useState({});
  const [candidateSources, setCandidateSource] = useState([]);
  const [candidateSourceRCIds, setCandidateSourceRCIds] = useState({});
  const [candidateSourceDFIds, setCandidateSourceDFIds] = useState({});
  const RECOMENDED_CODE = "RC";
  const DF_CODE = "DF";
  const LI_CODE = "LI";
  const [pageSize, setPageSize] = useState(10);
  const [jobRoles, setJobRoles] = useState([]);
  const [showModalSelectDNALanguage, setShowSelectDNALanguage] = useState(
    false
  );
  const [
    showModalDNASentSuccessfully,
    setShowModalDNASentSuccessfully
  ] = useState(false);
  const [preCandidateId, setPreCandidateId] = useState(0);
  const [canPageLoad, setCanPageLoad] = useState(false);
  const { t } = useTranslation();
  const [openCreateScreenCall, setOpenCreateScreenCall] = useState(false);
  useEffect(() => {
    getAvailabilityStatus();
    CommonService.getCandidateSources().then((data) => {
      setCandidateSource(translateAndSortAscendant(data, "description"));
      let _candidateSourceRCIds = {};
      data
        .filter((x) => x.code === RECOMENDED_CODE)
        .map((x) => x.id)
        .forEach((x) => (_candidateSourceRCIds[x] = true));
      setCandidateSourceRCIds(_candidateSourceRCIds);
    });
  }, []);

  useEffect(() => {
    getAvailabilityStatus();
    CommonService.getCandidateSources().then((data) => {
      setCandidateSource(translateAndSortAscendant(data, "description"));
      let _candidateSourceDFIds = {};
      data
        .filter((x) => x.code === DF_CODE || x.code === LI_CODE)
        .map((x) => x.id)
        .forEach((x) => (_candidateSourceDFIds[x] = true));
      setCandidateSourceDFIds(_candidateSourceDFIds);
    });
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSearchObjectParams = Object.fromEntries(urlParams.entries());
    if (urlSearchObjectParams.precandidateId) {
      openDeletePreCandidateModal(
        null,
        Number(urlSearchObjectParams.precandidateId)
      );
      getPreCandidate();
      setCanPageLoad(true);
    } else if (Object.keys(urlSearchObjectParams).length > 0) {
      let newSearchObject = QueryString.getJsonObject("searchObject");
      setCanPageLoad(true);
      setSearchObject(newSearchObject);
      getPreCandidate(newSearchObject);
    } else {
      getPreCandidate();
      setCanPageLoad(true);
    }
    LoadManagers();
  }, []);

  useEffect(() => {
    if (canPageLoad) {
      getPreCandidate(searchObject);
    }
  }, [pageNumber, pageSize, searchObject.order, searchObject.orderby]);

  useEffect(() => {
    let firstPage = 1;
    if (canPageLoad) {
      if (pageNumber !== firstPage) {
        setPageNumber(firstPage);
      }
    }
  }, [searchObject]);

  useEffect(() => {
    if (!jobRoles || jobRoles.length === 0) {
      jobRoleService.getRoles().then((result) => {
        setJobRoles(translateAndSortAscendant(result, "description"));
      });
    }
  }, []);

  function openModalCreateInterviewOrScreenCall(preCandidateId, isInterview) {
    setPreCandidateId(preCandidateId);
    if (isInterview) setShowCreteInterviewConfirmation(true);
    else setOpenCreateScreenCall(true);
  }

  function closeModalError() {
    setModalErrorOpen(false);
  }

  function openModalError() {
    setModalErrorOpen(true);
  }

  useEffect(() => {
    PreCandidateService.GetReasons().then((reasons) => setReasons(reasons));
  }, []);

  async function createPrecandidatecallbackError(res) {
    let error = await res.json();
    while (true) {
      if (!error.data) break;
      if (!error.data.precandidateExist) break;
      if (error.data.interviewId) {
        setModalErrorRedirect({
          ...modalErrorRedirect,
          interviewId: error.data.interviewId
        });
      } else {
        setModalErrorRedirect({
          ...modalErrorRedirect,
          precandidateId: error.data.precandidateId
        });
      }
      openModalError();
      return;
    }
    showError(t(`translation:${error.message.text}`));
  }

  const onChange = ({ target }) => {
    let _preCandidate = { ...precandidate };
    let phoneNumber = new RegExp("^[+]{0,1}[0-9 ]*$");
    if (target.name === "phoneNumber")
      if (target.value !== undefined) {
        phoneNumber.test(target.value);
      } else {
        target.value = "";
      }

    if (target.name === "techAreaId" && !target.value) {
      _preCandidate.techRoleId = null;
    }
    if (target.value) _preCandidate[target.name] = target.value;
    else _preCandidate[target.name] = null;
    setPrecandidate(_preCandidate);
  };

  function getAvailabilityStatus() {
    PreCandidateService.GetAvailabilityStatus().then((status) =>
      setAvailabilityStatus(status)
    );

    PreCandidateService.getContactAvailabilityStatus().then((data) =>
      setContactavailabilityStatus(data)
    );
  }

  function getPreCandidate(_searchObject = searchObject) {
    setIsPreCandidateLoading(true);
    if (_searchObject.techRoleId === null) {
      _searchObject.techRoleId = "";
    }
    PreCandidateService.GetPrecandidatesPaginated(
      pageNumber,
      pageSize,
      _searchObject
    )
      .then((_result) => {
        setPreCandidateList(_result.preCandidates);
        if (_result.total <= pageSize) {
          setTotalPages(1);
        } else {
          setTotalPages(Math.ceil(_result.total / pageSize));
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("Something went wrong."));
      })
      .finally(() => {
        setIsPreCandidateLoading(false);
      });
  }

  function LoadManagers() {
    PreCandidateService.getPrecandidateManagers().then((_managers) =>
      setManagers(_managers)
    );
  }

  function getContactReasons() {
    PreCandidateService.GetReasons().then((_reasons) => setReasons(_reasons));
  }

  function UpdatePreCandidate(event) {
    event.preventDefault();
    if (!validatePreCandidate()) return;
    let _precandidate = { ...precandidate };
    _precandidate.phoneNumber = _precandidate.phoneNumber?.trim();

    _precandidate.businessAreas = _precandidate.businessAreas.map(
      (item) => item.id
    );
    PreCandidateService.EditPrecandidate(
      _precandidate,
      createPrecandidatecallbackError
    ).then((res) => {
      if (res && res.error) return;
      setUpdatePreCandidateList(!updatePreCandidateList);
      setModalEditShow(false);
      onCloseForm();
      toast.success(t("Successfully saved"));
    });
  }

  function CreateCandidateInteraction(event) {
    event.preventDefault();
    if (!validateContactPreCandidate()) {
      return;
    }

    PreCandidateService.CreateCandidateInteraction(
      contactPreCandidate
    ).then(() => setUpdatePreCandidateList(!updatePreCandidateList));
    setModalContactShow(false);
    onCloseForm();
  }

  function openContactModal(event, _preCandidateId, _fullName) {
    event.stopPropagation();
    getContactReasons();
    setPreCandidateSelected(_fullName);
    let _contactPreCandidateDefault = {
      preCandidateId: _preCandidateId
    };
    setPreCandidateSelected(_fullName);
    setContactPreCandidate(_contactPreCandidateDefault);
    setModalContactShow(true);
  }

  function openDeletePreCandidateModal(event, _preCandidateID) {
    if (event) event.stopPropagation();
    PreCandidateService.GetPrecandidateById(_preCandidateID).then((result) =>
      setPrecandidate(result)
    );
    setModalDeleteShow(true);
  }

  function openHistoryModal(event, _preCandidateId, _fullName) {
    event.stopPropagation();
    setPreCandidateSelected(_fullName);
    (async () => {
      const result = await PreCandidateService.GetPreCandidateHistory(
        _preCandidateId
      );
      setHistoryPreCandidate(result.assignmentsAndInteractions);
    })().then(() => setModalHistoryShow(true));
  }

  function onChangeContactPreCandidate({ target }) {
    let _contactPreCandidate = { ...contactPreCandidate };
    _contactPreCandidate[target.name] = target.value;
    setContactPreCandidate(_contactPreCandidate);
  }

  function onChangeAvailabilityStatusContactPreCandidate(
    id,
    availabilityStatusCode
  ) {
    setContactPreCandidate((prevState) => ({
      ...prevState,
      availabilityStatusId: id,
      availabilityStatusCode: availabilityStatusCode
    }));
    availabilityStatusCode !== "UN" &&
      setContactPreCandidate((prevState) => ({
        ...prevState,
        availabilityReasonId: 0
      }));
    setErros({});
  }

  function onChangeNextContactDate(date) {
    let _contactPreCandidate = { ...contactPreCandidate };
    let _erros = { ...errors };
    const lastWeek = moment().subtract(8, "days");
    if (!date._d && date !== "") {
      _erros.nextContactDate = t("The date and time are invalid.");
    } else if (moment(date).isBefore(lastWeek)) {
      _erros.nextContactDate = t("The date and time are invalid.");
    } else {
      _erros.nextContactDate = undefined;
    }
    setErros(_erros);
    _contactPreCandidate["nextContactDate"] = date._d;
    setContactPreCandidate(_contactPreCandidate);
  }

  function validateContactPreCandidate() {
    const _erros = {};
    //validate for empty fields
    let errorMessageNectContactDate = validateNextContact();
    if (errorMessageNectContactDate !== "") {
      _erros.nextContactDate = errorMessageNectContactDate;
    }

    const lastWeek = moment().subtract(8, "days");

    if (
      !contactPreCandidate.availabilityStatusId &&
      !contactPreCandidate.nextContactDate &&
      !contactPreCandidate.comments
    ) {
      _erros.contact = t("Unfilled contact");
    }

    if (contactPreCandidate.availabilityStatusId) {
      if (
        contactPreCandidate.availabilityStatusCode === "UN" &&
        !contactPreCandidate.availabilityReasonId
      ) {
        _erros.availabilityReasonId = t("Reason is required.");
      }
    }

    if (
      !contactPreCandidate.availabilityStatusId &&
      contactPreCandidate.nextContactDate
    ) {
      _erros.availabilityStatusId = t(
        "You need to mark the status as Scheduled or On Hold"
      );
    }

    if (contactPreCandidate.comments) {
      if (contactPreCandidate.comments.length > 500) {
        _erros.comments = t("The maximum number of characters allowed is 500.");
      }
    }

    if (moment().isBefore(lastWeek)) {
      _erros.nextContactDate = t("The date must from the last week of after");
    }

    setErros(_erros);
    return Object.keys(_erros).length === 0;
  }

  function validateNextContact() {
    let errorMessage = "";
    if (errors.nextContactDate) {
      return errors.nextContactDate;
    } else if (
      contactPreCandidate.availabilityStatusCode === "SCH" ||
      contactPreCandidate.availabilityStatusCode === "FD" ||
      contactPreCandidate.availabilityStatusCode === "OH"
    ) {
      if (!contactPreCandidate.nextContactDate) {
        errorMessage = t("The contact date and time are required.");
      } else {
        errorMessage = "";
      }
    }
    return errorMessage;
  }

  function validatePreCandidate() {
    const _erros = {};
    //validate for empty fields
    if (!precandidate.fullName)
      _erros.fullName = t("The Full Name is required.");

    if (!precandidate.emailAddress)
      _erros.emailAddress = t("The Email Address is required.");

    if (precandidate.fullName) {
      if (precandidate.fullName.length > 100)
        _erros.fullName = t("The maximum number of characters allowed is 100.");
    }

    if (precandidate.emailAddress) {
      if (!emailPattern.test(precandidate.emailAddress))
        _erros.emailAddress = t("The Email Address format is invalid.");
    }
    if (precandidate.recommendedByEmail) {
      if (!emailPattern.test(precandidate.recommendedByEmail))
        _erros.recommendedByEmail = t("The Email Address format is invalid.");
    }

    if (candidateSourceRCIds[precandidate.candidateSourceId]) {
      if (
        precandidate.recommendedByEmail === "" ||
        precandidate.recommendedByEmail === null ||
        precandidate.recommendedByEmail === undefined
      ) {
        _erros.recommendedByEmail = t("Recommended Email is required.");
      }

      if (
        precandidate.recommendedByName === "" ||
        precandidate.recommendedByName === null ||
        precandidate.recommendedByName === undefined
      ) {
        _erros.recommendedByName = t("Recommended Name is required.");
      }
    }

    if (precandidate.phoneNumber) {
      if (precandidate.phoneNumber.length > 25)
        _erros.phoneNumber = t("The max number of characters is 18.");
    }

    if (!precandidate.candidateSourceId) {
      _erros.candidateSourceId = t("The Source is required.");
    }
    setErros(_erros);
    return Object.keys(_erros).length === 0;
  }

  function onCloseForm() {
    getPreCandidate();
    setPrecandidate({});
    setErros({});
  }

  function clearPrecandidateData() {
    setPrecandidate({});
    setErros({});
  }

  function onChangeSearch({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  return (
    <PreCandidateContext.Provider
      value={{
        modalHistoryShow,
        modalEditShow,
        modalDeleteShow,
        modalContactShow,
        modalShow,
        setModalShow,
        setModalEditShow,
        setModalDeleteShow,
        setModalContactShow,
        setModalHistoryShow,
        precandidate,
        setPrecandidate,
        onChange,
        pageNumber,
        setPageNumber,
        pageSize,
        totalPages,
        availabilityStatus,
        setAvailabilityStatus,
        onChangeSearch,
        searchObject,
        preCandidateList,
        setPreCandidateList,
        CreateCandidateInteraction,
        setContactPreCandidate,
        openContactModal,
        reasons,
        onChangeContactPreCandidate,
        onChangeNextContactDate,
        onChangeAvailabilityStatusContactPreCandidate,
        errors,
        openDeletePreCandidateModal,
        openHistoryModal,
        historyPreCandidate,
        updatePreCandidateList,
        setUpdatePreCandidateList,
        managers,
        LoadManagers,
        onCloseForm,
        validatePreCandidate,
        UpdatePreCandidate,
        contactPreCandidate,
        setReasons,
        precandidateSelected,
        setErros,
        showCreteInterviewConfirmation,
        setShowCreteInterviewConfirmation,
        alertMessageToCreateInterview,
        setAlertMessageToCreateInterview,
        interviewId,
        setInterviewId,
        setSearchObject,
        isPreCandidateLoading,
        modalErrorOpen,
        closeModalError,
        modalErrorRedirect,
        showModalSelectDNALanguage,
        setShowSelectDNALanguage,
        preCandidateId,
        setPreCandidateId,
        showModalDNASentSuccessfully,
        setShowModalDNASentSuccessfully,
        contactavailabilityStatus,
        candidateSources,
        candidateSourceRCIds,
        candidateSourceDFIds,
        createPrecandidatecallbackError,
        setPageSize,
        openModalCreateInterviewOrScreenCall,
        openCreateScreenCall,
        setOpenCreateScreenCall,
        jobRoles,
        setJobRoles,
        getPreCandidate,
        clearPrecandidateData
      }}
    >
      {children}
    </PreCandidateContext.Provider>
  );
}

export function usePrecandidateContext() {
  return useContext(PreCandidateContext);
}
